export const toFormData = json => {
  const formData = new FormData()
  Object.entries(json).forEach(([key, value]) => {
    // check value is array or not
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        formData.append(`${key}[]`, item)
      })
    } else {
      formData.append(key, value)
    }
  })
  return formData
}
